import { ref, Ref, nextTick, watch } from 'vue'
export default () => {
  const STableRef = ref()
  const SChildTableRefs: Ref<any[]> = ref([])
  const pageData = ref({
    page: 1,
    limit: 10
  })
  // 每页勾选情况
  const selectPageOption: any = ref({})
  watch(pageData, (newValue: any, oldValue) => {
    if (oldValue.limit !== newValue.limit) {
      selectPageOption.value = {}
    }
  })

  const changeSelectFn = (data: any) => {
    const ids = (selectPageOption.value[pageData.value.page] && selectPageOption.value[pageData.value.page].map((item: any) => item.platformOrderId)) || []
    nextTick(() => {
      data.forEach((item: any) => {
        if (ids.indexOf(item.platformOrderId) > -1) {
          STableRef.value.toggleRowSelection(item)
        }
      })
    })
  }

  const refreshTable = (type?: boolean) => {
    if (type) {
      pageData.value = {
        page: 1,
        limit: 30
      }
    }
    selectPageOption.value = {}
    nextTick(() => {
      STableRef.value && STableRef.value.getData()
    })
  }
  const expandList: any = ref([])
  const handleExpandRow = (val: any, flag: boolean) => {
    if (flag) {
      expandList.value.push(val.platformOrderId)
      val._pageData = {
        page: 1,
        limit: 10
      }
      nextTick(() => {
        SChildTableRefs.value[val.platformOrderId].getData()
      })
    } else {
      const idx = expandList.value.findIndex((e: any) => e === val.platformOrderId)
      expandList.value.splice(idx, 1)
    }
  }
  const handleExpandAll = (val: any, flag: boolean) => {
    if (flag) {
      expandList.value = val
      for (const el of val) {
        nextTick(() => {
          SChildTableRefs.value[el].getData()
        })
      }
    } else {
      expandList.value = []
    }
  }

  const toggleExpandAllChange = (val: any) => {
    nextTick(() => {
      SChildTableRefs.value[val.platformOrderId].expandAllChange()
    })
  }
  // 当前页勾选
  const selectedOrderList: any = ref([])
  // 勾选
  const handleSelectionChange = (val: any) => {
    selectPageOption.value[pageData.value.page] = val
    selectedOrderList.value = val
  }

  return {
    STableRef,
    pageData,
    refreshTable,
    SChildTableRefs,
    handleExpandRow,
    handleExpandAll,
    selectedOrderList,
    expandList,
    handleSelectionChange,
    toggleExpandAllChange,
    changeSelectFn,
    selectPageOption
  }
}
